import Cookies from "js-cookie";

const TokenKey = "loginToken";
const SupplierIdKey = "supplierId";
const PharmacyIdKey = "pharmacyId";
const OutPharmacyIdKey = "outPharmacyId";
const HospitalPartnerIdKey = "hospitalPartnerId";
const SubsidiaryIdKey = "subsidiaryId";
const IsSupplierLoginKey = "isSupplierLogin";
const IsPlatLoginKey = "isPlatLogin";
const IsSubsidiaryLoginKey = "isSubsidiaryLogin";
const IsPharmacyLoginKey = "isPharmacyLogin";
const IsOutPharmacyLoginKey = "isOutPharmacyLogin";
const IsProducterLoginKey = "isProducterLogin";
const IsAdminLoginKey = "isAdminLogin";
const AuthFinanceAccountIdsKey = "authFinanceAccountIds";

const SupplierAgentIdKey = "supplierAgentId";
const IsSupplierAgentLoginKey = "isSupplierAgentLogin";

const IsSpecialPharmacyLoginKey = "IsSpecialPharmacyLoginKey";

const LoginSupplierCodeKey = "LoginSupplierCodeKey";


export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function getLoginSupplierCode() {
  return Cookies.get(LoginSupplierCodeKey);
}

export function setLoginSupplierCode(code) {
  return Cookies.set(LoginSupplierCodeKey, code);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getSubsidiaryId() {
  return Cookies.get(SubsidiaryIdKey);
}

export function setSubsidiaryId(subsidiaryId) {
  return Cookies.set(SubsidiaryIdKey, subsidiaryId);
}

export function getSupplierId() {
  return Cookies.get(SupplierIdKey);
}

export function setSupplierId(supplierId) {
  return Cookies.set(SupplierIdKey, supplierId);
}

export function getSupplierAgentId() {
  return Cookies.get(SupplierAgentIdKey);
}

export function setSupplierAgentId(supplierAgentId) {
  return Cookies.set(SupplierAgentIdKey, supplierAgentId);
}


export function getPharmacyId() {
  return Cookies.get(PharmacyIdKey);
}
export function setPharmacyId(pharmacyId) {
  return Cookies.set(PharmacyIdKey, pharmacyId);
}

export function getOutPharmacyId() {
  return Cookies.get(OutPharmacyIdKey);
}
export function setOutPharmacyId(outPharmacyId) {
  return Cookies.set(OutPharmacyIdKey, outPharmacyId);
}

export function getHospitalPartnerId() {
  return Cookies.get(HospitalPartnerIdKey);
}
export function setHospitalPartnerId(hospitalPartnerId) {
  return Cookies.set(HospitalPartnerIdKey, hospitalPartnerId);
}

export function isSupplierLogin() {
  return Cookies.get(IsSupplierLoginKey);
}
export function setIsSupplierLogin(isSupplierLogin) {
  return Cookies.set(IsSupplierLoginKey, isSupplierLogin);
}

export function isSupplierAgentLogin() {
  return Cookies.get(IsSupplierAgentLoginKey);
}
export function setIsSupplierAgentLogin(isSupplierAgentLogin) {
  return Cookies.set(IsSupplierAgentLoginKey, isSupplierAgentLogin);
}


export function isPlatLogin() {
  return Cookies.get(IsPlatLoginKey);
}
export function setIsPlatLogin(isPlatLogin) {
  return Cookies.set(IsPlatLoginKey, isPlatLogin);
}

export function isSpecialPharmacyLogin() {
  return Cookies.get(IsSpecialPharmacyLoginKey);
}
export function setIsSpecialPharmacyLogin(isSpecialPharmacyLogin) {
  return Cookies.set(IsSpecialPharmacyLoginKey, isSpecialPharmacyLogin);
}

export function isSubsidiaryLogin() {
  return Cookies.get(IsSubsidiaryLoginKey);
}
export function setIsSubsidiaryLogin(subsidiaryLogin) {
  return Cookies.set(IsSubsidiaryLoginKey, subsidiaryLogin);
}
export function isPharmacyLogin() {
  return Cookies.get(IsPharmacyLoginKey);
}
export function setIsPharmacyLogin(pharmacyLogin) {
  return Cookies.set(IsPharmacyLoginKey, pharmacyLogin);
}
export function isProducterLogin() {
  return Cookies.get(IsProducterLoginKey);
}
export function setIsProducterLogin(producterLogin) {
  return Cookies.set(IsProducterLoginKey, producterLogin);
}
export function isOutPharmacyLogin() {
  return Cookies.get(IsOutPharmacyLoginKey);
}
export function setIsOutPharmacyLogin(outPharmacyLogin) {
  return Cookies.set(IsOutPharmacyLoginKey, outPharmacyLogin);
}
export function isAdminLogin() {
  return Cookies.get(IsAdminLoginKey);
}
export function setIsAdminLogin(adminLogin) {
  return Cookies.set(IsAdminLoginKey, adminLogin);
}

export function getAuthFinanceAccountIds() {
  return Cookies.get(AuthFinanceAccountIdsKey);
}

export function setAuthFinanceAccountIds(authFinanceAccountIds) {
  return Cookies.set(AuthFinanceAccountIdsKey, authFinanceAccountIds);
}
